import React from 'react'
import Scaner1 from "../../Assets/Images/scaner1.png"
import Scaner4 from "../../Assets/Images/scaner4.png"
import Scaner5 from "../../Assets/Images/scaner5.png"
function Scaner() {
    return (
        <section className='bg-[#FF9C4E] py-[50px]'>
            <div className='container px-3 mx-auto'>
                <div data-aos="fade-up" className='lg:w-[47%] mx-auto'>
                    <h2 className='text-[30px] mb-4 text-center sm:text-[35px] leading-[40px] font-bold text-white'>Беспроводной 2D сканер штрихкода для маркировки</h2>
                    <p className='text-white text-center text-[14px] sm:text-[18px] '>Двумерные сканеры представляют собой наиболее универсальные считывающие устройства. Они способны считать все типы кодов: 1D, 2D, DataMatrix и составные.</p>
                </div>
                <div className='flex flex-col md:flex-row items-center justify-center mt-10 gap-5'>
                    <div data-aos="zoom-in-up" className='w-[200px] sm:w-[300px] object-contain h-[200px] sm:h-[300px] p-5 rounded-lg bg-[#6F42C1] flex items-center justify-center'>
                        <img className='scale-[0.6]' src={Scaner1} alt='Scaner img' width={300} height={300} />
                    </div>
                    <div data-aos="zoom-in-up" className='w-[200px] sm:w-[300px] object-contain h-[200px] sm:h-[300px] p-5 rounded-lg bg-[#6F42C1] flex items-center justify-center'>
                        <img className='scale-[1]' src={Scaner4} alt='Scaner img' width={300} height={300} />
                    </div>
                    <div data-aos="zoom-in-up" className='w-[200px] sm:w-[300px] object-contain h-[200px] sm:h-[300px] p-5 rounded-lg bg-[#6F42C1] flex items-center justify-center'>
                        <img className='scale-[1.2]' src={Scaner5} alt='Scaner img' width={300} height={300} />
                    </div>
                </div>
                <div className='flex mt-2 sm:mt-8 lg:w-[940px] mx-auto gap-5 lg:gap-10'>
                    <div class="space-y-4 w-full">
                        <div class="flex items-center">
                            <span class="text-white text-[15px] sm:text-[22px]">Тип</span>
                            <div class="flex-grow border-dashed border-b border-gray-600 mx-2"></div>
                            <span class="text-white text-[15px] sm:text-[22px]">Сканер штрих-кодов</span>
                        </div>
                        <div class="flex items-center">
                            <span class="text-white text-[15px] sm:text-[22px]">Цвет</span>
                            <div class="flex-grow border-dashed border-b border-gray-600 mx-2"></div>
                            <span class="text-white text-[15px] sm:text-[22px]">Черный матовый</span>
                        </div>
                        <div class="flex items-center">
                            <span class="text-white text-[15px] sm:text-[22px]">Тип связи</span>
                            <div class="flex-grow border-dashed border-b border-gray-600 mx-2"></div>
                            <span class="text-white text-[15px] sm:text-[22px]">Bluetooth, Радио, Проводной</span>
                        </div>
                        <div class="flex items-center">
                            <span class="text-white text-[15px] sm:text-[22px]">Сканер кодов</span>
                            <div class="flex-grow border-dashed border-b border-gray-600 mx-2"></div>
                            <span class="text-white text-[15px] sm:text-[22px]">2D, 1D, QR Code, DATA MATRIX</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Scaner